import { getJson, putJson, deleteJson, withDone } from '@rad/utility/http';
export const getSavedProperties = getJson('/api/saved-properties');
// Parcel ids.
export const getSavedPropertyIds = getJson('/api/saved-properties/ids');
export const saveProperty = (parcelId) => withDone(putJson(`/api/saved-properties/${parcelId}`))();
export const unsaveProperty = (parcelId) => withDone(deleteJson(`/api/saved-properties/${parcelId}`))();
